import { css } from "@emotion/css";
import { space } from "@octopusdeploy/design-system-tokens";
import type { DeploymentFreezeSummary } from "@octopusdeploy/octopus-server-client";
import React from "react";
import { ProjectChip } from "~/components/Chips/index";
import { DataTableRowColumn } from "~/primitiveComponents/dataDisplay/DataTable/index";
interface DeploymentFreezeDataTableProjectsCellProps {
    freeze: DeploymentFreezeSummary;
}
export const DeploymentFreezeDataTableProjectsCell = ({ freeze }: DeploymentFreezeDataTableProjectsCellProps) => {
    const projects = freeze.Projects;
    if (projects.Items.length === 0) {
        return (<DataTableRowColumn className={cellStyles}>
                <div className={noProjectsStyles}>No projects</div>
            </DataTableRowColumn>);
    }
    return (<DataTableRowColumn className={cellStyles}>
            <div className={projectCellStyles}>
                {projects.Items.length > 0 && (projects.Items.length === 1 ? <ProjectChip projectName={projects.Items[0].Name}/> : <ProjectChip projectName={`${projects.Items.length + (projects.MoreItems || 0)} projects`} noTooltip={true}/>)}
            </div>
        </DataTableRowColumn>);
};
const noProjectsStyles = css({
    margin: space[4],
});
const projectCellStyles = css({
    display: "flex",
    gap: space[4],
    justifyContent: "flex-start",
    verticalAlign: "middle",
});
const cellStyles = css({ width: "15%" });
